import { put, takeLatest, takeLeading, all, call, select } from 'redux-saga/effects';
import { actions } from 'react-redux-form';
import {
	CHECK_EXISTING_USER,
	CHECK_EXISTING_USER_SUCCESS,
	CHECK_EXISTING_USER_ERROR,
	GET_OPTIONS,
	GET_OPTIONS_SUCCESS,
	GET_OPTIONS_ERROR,
	REFRESH_USER,
	REFRESH_USER_SUCCESS,
	REFRESH_USER_ERROR,
	FREE_ACCESS,
	FREE_ACCESS_SUCCESS,
	FREE_ACCESS_ERROR,
	AUDIT,
	AUDIT_SUCCESS,
	AUDIT_ERROR,
	GET_TRIAL_SCHEDULES,
	TRIAL_SCHEDULES_RECEIVED,
	TRIAL_SCHEDULES_ERROR,
	GET_SCHEDULES,
	SCHEDULES_RECEIVED,
	SCHEDULES_ERROR,
	GET_HEALTH_SCORES,
	HEALTH_SCORES_RECEIVED,
	HEALTH_SCORES_ERROR,
	MATCH_SUCCESS,
	MATCH_ERROR,
	GET_MATCH,
	GET_PLAYER,
	PLAYER_SUCCESS,
	PLAYER_ERROR,
	SIGNUP,
	SIGNUP_SUCCESS,
	SIGNUP_ERROR,
	LOGIN,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
	GOOGLE_AUTH,
	GOOGLE_AUTH_ERROR,
	X_AUTH_EXCHANGE,
	X_AUTH_COMPLETE,
	X_AUTH_ERROR,
	LOGOUT,
	LOGOUT_ERROR,
	SEND_PASSWORD_RESET,
	SEND_PASSWORD_RESET_SUCCESS,
	SEND_PASSWORD_RESET_ERROR,
	UPDATE_PROFILE_SUCCESS,
	VERIFY_PASSWORD_RESET_TOKEN,
	VERIFY_PASSWORD_RESET_TOKEN_SUCCESS,
	VERIFY_PASSWORD_RESET_TOKEN_ERROR,
	RESET_PASSWORD,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_ERROR,
	CHECK_LOGIN,
	CHECK_LOGIN_SUCCESS,
	CHECK_LOGIN_ERROR,
	MAKE_SAMPLE_TOKEN,
	UPDATE_PROFILE,
	MAKE_SAMPLE_TOKEN_SUCCESS,
	MAKE_SAMPLE_TOKEN_ERROR,
	GET_PRICES,
	GET_PRICES_SUCCESS,
	GET_PRICES_ERROR,
	PURCHASE_PLAN,
	PURCHASE_PLAN_SUCCESS,
	PURCHASE_PLAN_ERROR,
	TEAM_SCORES,
	TEAM_SCORES_RECEIVED,
	TEAM_SCORES_ERROR,
	VIEW_TEAM,
	VIEW_TEAM_SUCCESS,
	VIEW_TEAM_ERROR,
	TEAM_SCHEDULE,
	TEAM_SCHEDULE_SUCCESS,
	TEAM_SCHEDULE_ERROR,
	GET_DASHBOARD_OPTIONS,
	ADMIN_DASHBOARD_SEARCH_SUBMIT,
	ADMIN_DASHBOARD_CHANGE_SUBMIT,
	ADMIN_DASHBOARD_INSERT_SUBMIT,
	GET_ADMIN_CSV,
	RUN_CALCULATIONS,
	CANCEL_SUBSCRIPTION,
	CANCEL_SUBSCRIPTION_SUCCESS,
	CANCEL_SUBSCRIPTION_ERROR,
	GET_TEAM_HEALTH_SCORE_NFL,
	CREATE_SUBSCRIPTION,
	CREATE_SUBSCRIPTION_SUCCESS,
	CREATE_SUBSCRIPTION_ERROR,
	LOGOUT_SUCCESS,
	SEARCH_GAMES,
	SUBMIT_ADMIN_CHANGES,
	GAME_PLAYER_INFO,
	GAME_PLAYER_INFO_ERROR,
	ADMIN_GET_DFS_PICKS,
	ADMIN_SAVE_DFS_PICK,
	ADMIN_DELETE_DFS_PICK,
	ADMIN_SEARCH_DFS_PLAYERS,
	GET_DFS_PICKS,
	GET_DFS_PICKS_SUCCESS,
	GET_DFS_PICKS_ERROR,
	GET_TBD_PLAYERS,
	SET_PLAYER_RETURN_DATE,
	CLEAR_PLAYER_RETURN_DATE
} from './constants';
import { request, toLocalTime } from '../components/utils/index';
import * as selectors from './selectors';
import { adminDashboardOptions, adminDashboardSearch, adminDashboardChange, adminDashboardInsert, adminDashboardCSV, adminDashboardRunCalculations, adminTeamHealthScoreNFL, searchGames, submitAdminChanges, adminGetDfsPicks, adminSaveDfsPick, adminDeleteDfsPick, adminSearchDfsPlayers, getTBDPlayers, setPlayerReturnDate, clearPlayerReturnDate } from './adminSaga';
import { resolvePostAuthReturnUrl, shouldRedirectAfterAuth } from '../utils/authRedirect';
import { buildXCompleteUrl, clearXCompletionState, getXAuthErrorMessage, storeXCompletionState } from '../utils/xAuth';
// import { result } from "lodash";
// import axios from "axios";

const sportsIndexArr = ['nfl', 'nba', 'soccer', 'cricket'];

function getSportIndex(url) {
	for (let x = 0; x < url.length; x++) {
		if (sportsIndexArr.includes(url[x].toLowerCase())) {
			return {
				sportsID: sportsIndexArr.indexOf(url[x]) + 1,
				sportsName: url[x].toLowerCase()
			};
		}
	}
}

function getAuthErrorMessage(result, error, fallbackMessage) {
	return (
		error?.response?.data?.message ||
		result?.data?.message ||
		error?.message ||
		fallbackMessage
	);
}

function redirectAfterAuth(returnUrl) {
	const nextUrl = resolvePostAuthReturnUrl(returnUrl, window.location.search);
	if (shouldRedirectAfterAuth(nextUrl, window.location.pathname, window.location.search)) {
		window.location.href = nextUrl;
	}
}

function isEmailVerified(userData) {
	return Boolean(userData?.emailVerified || Number(userData?.email_verified));
}

function redirectToXCompletion(returnUrl, verification = false) {
	window.location.href = buildXCompleteUrl(returnUrl, verification);
}

function* checkExistingUser(action) {
	let result;
	const { email } = action.payload;
	try {
		result = yield call(request, `/get/checkusername/${email}`, {
			method: 'GET',
			cache: 'no-cache',
			headers: {
				'cache-control': 'no-cache',
				'Content-Type': 'application/json'
			}
		});
		if (result.data.status) {
			yield put({
				type: CHECK_EXISTING_USER_SUCCESS
			});
		} else {
			yield put({
				type: CHECK_EXISTING_USER_ERROR
			});
		}
	} catch (err) {
		//console.log(err);
		yield put({
			type: CHECK_EXISTING_USER_ERROR
		});
	}
}

function* getDfsPicks(action = {}) {
	const { sportsID } = action.payload || {};
	const path = sportsID ? `/dfs-picks?sportsID=${sportsID}` : '/dfs-picks';
	try {
		const result = yield request(null, path, 'GET');
		const body = result?.data;
		if (body?.status === false) {
			yield put({
				type: GET_DFS_PICKS_ERROR,
				payload: { message: body?.message || 'Failed to load picks' }
			});
		} else {
			const picks = body?.data?.picks || body?.picks || {};
			yield put({ type: GET_DFS_PICKS_SUCCESS, payload: { picks } });
		}
	} catch (error) {
		const status = error?.response?.status;
		if (status === 404) {
			yield put({ type: GET_DFS_PICKS_SUCCESS, payload: { picks: {} } });
			return;
		}
		yield put({
			type: GET_DFS_PICKS_ERROR,
			payload: { message: error?.message || 'Network error' }
		});
	}
}

function* getOptions() {
	let result;
	const user = yield select(selectors.user);
	try {
		result = yield request({}, `/options/${user?.sportsID || 1}`, 'GET');
		if (result.data.status) {
			yield put({
				type: GET_OPTIONS_SUCCESS,
				payload: {
					states: result?.data?.data?.states,
					nflScoreboard: result?.data?.data?.nflScoreboard || [],
					sportsInfo: result?.data?.data?.sportsInfo
				}
			});
		} else {
			yield put({
				type: GET_OPTIONS_ERROR
			});
		}
	} catch (err) {
		yield put({
			type: GET_OPTIONS_ERROR
		});
	}
}

function* freeAccess(action) {
	let result;
	const freeAccess = yield select(selectors.freeAccess);
	try {
		const data = { freeAccess };
		result = yield request(data, `/freeAccess`, 'POST');
		if (result.data.status) {
			yield put({
				type: FREE_ACCESS_SUCCESS
			});
			window.location.href = '/';
		} else {
			yield put({
				type: FREE_ACCESS_ERROR
			});
		}
	} catch (err) {
		//console.log(err);
		yield put({
			type: FREE_ACCESS_ERROR
		});
	}
}

function* storeAudit(action) {
	const user = yield select(selectors.user);
	let result;
	try {
		const data = {
			user: user?.email || 'guest_user',
			action: action.payload.user_action,
			meta: action.payload.meta || {}
		};
		result = yield request(data, `/audit`, 'POST');
		if (result.data.status) {
			yield put({
				type: AUDIT_SUCCESS
			});
		} else {
			yield put({
				type: AUDIT_ERROR
			});
		}
	} catch (err) {
		//console.log(err);
		yield put({
			type: AUDIT_ERROR
		});
	}
}

function* makeSampleToken(action) {
	let result;
	const existingToken = action.payload;
	try {
		if (!existingToken) {
			result = yield request({}, `/sampleToken`, 'GET');
			if (result.data.status) {
				yield put({
					type: MAKE_SAMPLE_TOKEN_SUCCESS,
					payload: {
						token: result.data?.data
					}
				});
			} else {
				yield put({
					type: MAKE_SAMPLE_TOKEN_ERROR
				});
			}
		} else {
			result = yield request({}, `/checkLogin`, 'GET', existingToken);
			if (!result.data.status) {
				result = yield request({}, `/sampleToken`, 'GET');
			} else {
				yield put({
					type: MAKE_SAMPLE_TOKEN_SUCCESS,
					payload: { token: existingToken }
				});
			}
		}
	} catch (err) {
		yield put({
			type: MAKE_SAMPLE_TOKEN_ERROR
		});
	}
}

function* checkLogin() {
	let user = yield select(selectors.user);
	let result;
	if (!user?.token) {
		yield put({
			type: CHECK_LOGIN_ERROR
		});
		return;
	}
	try {
		result = yield request({}, `/checkLogin`, 'GET', user?.token);
		if (result.data.status) {
			yield put({
				type: CHECK_LOGIN_SUCCESS
			});
		} else {
			yield put({
				type: LOGOUT
			});
		}
	} catch (err) {
		if (err?.response?.status === 401 || err?.statusCode === 401) {
			if (user?.login) {
				yield put({
					type: LOGOUT
				});
			} else {
				yield put({
					type: CHECK_LOGIN_ERROR
				});
			}
			return;
		}
		yield put({
			type: CHECK_LOGIN_ERROR
		});
	}
}

function* refreshUserInfo() {
	const user = yield select(selectors.user);
	let result;
	try {
		const data = {
			email: user?.email
		};
		result = yield request(data, `/refreshUser/${user?.id}`, 'GET', user?.token);
		console.log(result,'result')
		if (result.data.status) {
			yield put({
				type: REFRESH_USER_SUCCESS,
				payload: {
					...result.data?.data
				}
			});
			// }
		} else {
			yield put({
				type: REFRESH_USER_ERROR,
				payload: result.data.message
			});
		}
	} catch (err) {
		console.log(err);
		yield put({
			type: REFRESH_USER_ERROR
		});
	}
}

function* signup(action) {
	const { returnUrl, ...data } = action.payload;
	let result;
	try {
		result = yield request(data, '/signup', 'POST');
		if (result.data.status) {
			yield put({
				type: SIGNUP_SUCCESS,
				payload: {
					...result?.data?.data,
					message: result?.data?.message
				}
			});
            // Send signup email (temporarily disabled per request)
            // const user = yield select(selectors.user);
            // yield request({ email: data.email }, '/mail/signup', 'POST', user.token);
			// Show success message to the user before redirect
			// if (result?.data?.message) {
			// 	try {
			// 		window.alert(result.data.message);
			// 	} catch (e) {}
			// 	// Also surface message in global alert store
			// 	try {
			// 		yield put(actions.change('alertMessage.message', result.data.message));
			// 	} catch (e) {}
			// }
				// 🎯 User-facing message
			const successMessage = result?.data?.emailVerified
				? 'Signup successful. You are now logged in.'
				: `We’ve sent a verification email to ${data.email}. Please verify your email to activate your account.`;

			// Global alert banner
			yield put(
				actions.change('alertMessage.message', successMessage)
			);
			redirectAfterAuth(returnUrl);
		} else {
			const errMsg = result?.data?.message || 'Unable to complete signup. Please try again later.';
			yield put({
				type: SIGNUP_ERROR,
				payload: { message: errMsg }
			});
			// Surface error to global alert banner
			try {
				yield put(actions.change('alertMessage.error', errMsg));
			} catch (e) {}
		}
	} catch (error) {
		console.error(error);
		const errMsg = getAuthErrorMessage(result, error, 'Looks like there was an error creating your user profile, please try again later');
		yield put({
			type: SIGNUP_ERROR,
			payload: { message: errMsg }
		});
		// Surface error to global alert banner
		try {
			yield put(actions.change('alertMessage.error', errMsg));
		} catch (e) {}
		yield put({
			type: AUDIT,
			payload: {
				action: SIGNUP_ERROR,
				meta: error
			}
		});
	}
}

function* login(action) {
	const { login, returnUrl } = action.payload;
	let result;
	try {
		const data = {
			...login
		};
		result = yield request(data, '/login', 'POST');
		if (result.data.status) {
			yield put({
				type: LOGIN_SUCCESS,
				payload: {
					...result?.data?.data
				}
			});
			redirectAfterAuth(returnUrl);
		} else {
			yield put({
				type: LOGIN_ERROR,
				payload: { message: result?.data?.message || 'Incorrect Username/Password' }
			});
			// keep user on login page so message can be shown; no redirect here
		}
	} catch (error) {
		const errMsg = getAuthErrorMessage(result, error, 'Incorrect Username/Password');
		yield put({
			type: LOGIN_ERROR,
			payload: { message: errMsg }
		});
		yield put({
			type: AUDIT,
			payload: {
				action: LOGIN_ERROR,
				meta: error
			}
		});
		yield put(actions.change('alertMessage.error', errMsg));
	}
}

function* googleAuth(action) {
	const { credential, returnUrl } = action.payload || {};
	let result;
	try {
		result = yield request({ credential }, '/auth/google', 'POST');
		if (result.data.status) {
			yield put({
				type: LOGIN_SUCCESS,
				payload: {
					...result?.data?.data
				}
			});
			redirectAfterAuth(returnUrl);
			return;
		}

		const errMsg = result?.data?.message || 'Google sign-in failed. Please try again.';
		yield put({
			type: GOOGLE_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
	} catch (error) {
		const errMsg = getAuthErrorMessage(result, error, 'Google sign-in failed. Please try again.');
		yield put({
			type: GOOGLE_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
		yield put({
			type: AUDIT,
			payload: {
				action: GOOGLE_AUTH_ERROR,
				meta: error
			}
		});
	}
}

export function* finalizeXAuthSuccess(authData, returnUrl, completionState = {}) {
	yield put({
		type: LOGIN_SUCCESS,
		payload: {
			...authData
		}
	});

	if (isEmailVerified(authData)) {
		yield call(clearXCompletionState);
		yield call(redirectAfterAuth, returnUrl);
		return;
	}

	yield call(storeXCompletionState, {
		...completionState,
		prefill: {
			...(completionState?.prefill || {}),
			email: authData?.email || completionState?.prefill?.email || '',
			favorite_sport: authData?.favorite_sport || completionState?.prefill?.favorite_sport || 'NFL'
		},
		returnUrl: resolvePostAuthReturnUrl(returnUrl, window.location.search),
		verificationOnly: true
	});
	yield call(redirectToXCompletion, returnUrl, true);
}

export function* xAuthExchange(action) {
	const { exchangeCode, returnUrl } = action.payload || {};
	let result;
	try {
		result = yield call(request, { exchange_code: exchangeCode }, '/auth/x/exchange', 'POST');
		if (result.data.status) {
			const authData = result?.data?.data || {};
			if (authData?.requires_completion) {
				yield call(storeXCompletionState, {
					completion_token: authData?.completion_token || '',
					prefill: authData?.prefill || {},
					reason: authData?.reason || '',
					returnUrl: resolvePostAuthReturnUrl(returnUrl, window.location.search)
				});
				yield call(redirectToXCompletion, returnUrl);
				return;
			}

			yield call(finalizeXAuthSuccess, authData, returnUrl, {
				prefill: authData?.prefill || {},
				reason: authData?.reason || ''
			});
			return;
		}

		const errMsg = getXAuthErrorMessage(result?.data?.message || result?.data?.error);
		yield put({
			type: X_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
	} catch (error) {
		const errMsg = getAuthErrorMessage(result, error, 'X sign-in failed. Please try again.');
		yield put({
			type: X_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
		yield put({
			type: AUDIT,
			payload: {
				action: X_AUTH_ERROR,
				meta: error
			}
		});
	}
}

export function* xAuthComplete(action) {
	const { completionToken, email, favoriteSport, returnUrl } = action.payload || {};
	let result;
	try {
		result = yield call(
			request,
			{
				completion_token: completionToken,
				email,
				favorite_sport: favoriteSport
			},
			'/auth/x/complete',
			'POST'
		);
		if (result.data.status) {
			const authData = result?.data?.data || {};
			yield call(finalizeXAuthSuccess, authData, returnUrl, {
				completion_token: completionToken,
				prefill: {
					email,
					favorite_sport: favoriteSport
				}
			});
			return;
		}

		const errMsg = getXAuthErrorMessage(result?.data?.message || result?.data?.error);
		yield put({
			type: X_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
	} catch (error) {
		const errMsg = getAuthErrorMessage(result, error, 'Unable to complete X sign-in. Please try again.');
		yield put({
			type: X_AUTH_ERROR,
			payload: { message: errMsg }
		});
		yield put(actions.change('alertMessage.error', errMsg));
		yield put({
			type: AUDIT,
			payload: {
				action: X_AUTH_ERROR,
				meta: error
			}
		});
	}
}

function* sendPasswordReset(action) {
	const { email } = action?.payload;
	let result;
	try {
		const data = {
			email
		};
		result = yield request(data, '/mail/sendPasswordReset', 'POST');
		if (result.data.status) {
			yield put({
				type: SEND_PASSWORD_RESET_SUCCESS,
				payload: { message: result?.data?.message }
			});
			yield put(actions.change('alertMessage.message', result?.data?.message));
		} else {
			yield put({
				type: SEND_PASSWORD_RESET_ERROR,
				payload: { message: result?.data?.message }
			});
			yield put(actions.change('alertMessage.error', result?.data?.message));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: SEND_PASSWORD_RESET_ERROR,
			payload: { message: result?.data?.message }
		});
		yield put(actions.change('alertMessage.error', result?.data?.message));
	}
}

function* verifyPasswordReset(action) {
	const { token } = action.payload;
	let result;
	try {
		const data = {
			token
		};
		result = yield request(data, '/verifyPasswordReset', 'POST');
		if (result.data.status) {
			yield put({
				type: VERIFY_PASSWORD_RESET_TOKEN_SUCCESS,
				payload: { message: result?.data?.message, email: result.data?.data?.email }
			});
		} else {
			yield put({
				type: VERIFY_PASSWORD_RESET_TOKEN_ERROR,
				payload: { message: result?.data?.message }
			});
			yield put(actions.change('alertMessage.error', result?.data?.message));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: VERIFY_PASSWORD_RESET_TOKEN_ERROR,
			payload: { message: result?.data?.message }
		});
	}
}

function* resetPassword(action) {
	const { reset_password, token } = action?.payload;
	const passwordReset = yield select(selectors.passwordReset);
	let result;
	try {
		const data = {
			reset_password,
			email: passwordReset.email
		};
		result = yield request(data, '/resetPassword', 'POST', token);
		if (result.data.status) {
			yield put({
				type: RESET_PASSWORD_SUCCESS,
				payload: { message: result?.data?.message }
			});
		} else {
			yield put({
				type: RESET_PASSWORD_ERROR,
				payload: { message: result?.data?.message }
			});
			yield put(actions.change('alertMessage.error', result?.data?.message));
		}
	} catch (error) {
		console.log(error);
		yield put({
			type: RESET_PASSWORD_ERROR,
			payload: { message: result?.data?.message }
		});
		yield put(actions.change('alertMessage.error', result?.data?.message));
	}
}

function* logout() {
	const user = yield select(selectors.user);
	try {
		yield request({}, '/logout', 'GET', user?.token);
	} catch (error) {
		// Ignore API logout errors (expired token, network) and continue local logout flow.
	}
	yield put({
		type: LOGOUT_SUCCESS
	});
	window.location.href = '/login';
}

////////////////////////////////////////////////
function* fetchTrialSchedules(action) {
	try {
		// const trialSchedules = yield fetch(`/main/${sport}/trialschedules`).then(res =>
		const trialSchedules = yield fetch(`/main/nfl/trialschedules`).then((res) => res.json());
		yield put({
			type: TRIAL_SCHEDULES_RECEIVED,
			payload: trialSchedules
		});
	} catch (err) {
		yield put({
			type: TRIAL_SCHEDULES_ERROR,
			payload: 'Unable to retrieve trial schedules'
		});
	}
}

function* fetchSchedules(action) {
	const user = yield select(selectors.user);
	console.log(user,'user')
	let schedules;
	console.log(action,'action')
	const isCricket = Number(user?.sportsID) === 4 || (user?.sportsName || '').toLowerCase() === 'cricket';
	const append = Boolean(action?.payload?.append);
	const payloadLeague = action?.payload?.league || user?.league;
	const payloadSeason = action?.payload?.season;
	const payloadCursor = action?.payload?.cursor;
	const payloadLimit = action?.payload?.limit;
	try {
		if (isCricket) {
			const query = new URLSearchParams();
			if (payloadLeague) query.set('league', payloadLeague);
			// Default season to 2025 for IPL if not provided
			if (payloadSeason) {
				query.set('season', payloadSeason);
			} else if (payloadLeague === 'IPL') {
				query.set('season', '2025');
			}
			if (payloadCursor) query.set('cursor', payloadCursor);
			if (payloadLimit) query.set('limit', payloadLimit);
			const queryString = query.toString();
			schedules = yield request({}, `/api/cricket/schedules${queryString ? `?${queryString}` : ''}`, 'GET', user?.token);
		} else if(action?.payload?.league){
		    schedules = yield request({}, `/main/${user.sportsID || 1}/schedules?league=${action?.payload?.league}`, 'GET', user?.token);
		}
		else{
			schedules = yield request({}, `/main/${user.sportsID || 1}/schedules`, 'GET', user?.token);
		}
		try {
			schedules?.data?.data?.schedules?.map((s) => (s.date_time = toLocalTime(s.date_time)));
		} catch (error) {
			console.log(error);
		}
		yield put({
			type: SCHEDULES_RECEIVED,
			payload: {
				data: schedules.data?.data,
				append
			}
		});
	} catch (err) {		
		yield put({
			type: SCHEDULES_ERROR,
			payload: 'Unable to retrieve schedules'
		});
	}
	if (append || isCricket) {
		return;
	}
	yield put({
		type: TEAM_SCORES
	});
	try {
		const teamScoresUrl = `/main/${user.sportsID || 1}/healthScores?league=${user.league}`;
		const teamScores = yield request({}, teamScoresUrl, 'GET', user?.token);
		yield put({
			type: TEAM_SCORES_RECEIVED,
			payload: teamScores?.data?.data
		});
	} catch (err) {
		yield put({
			type: TEAM_SCORES_ERROR,
			payload: 'Unable to retrieve schedules'
		});
	}
	try {
		const playersUrl = isCricket
			? `/api/cricket/players?league=${payloadLeague || 'IPL'}`
			: `/main/players/${user.sportsID || 1}?league=${user.league}`;
		const players = yield request({}, playersUrl, 'GET', user?.token);
		yield put({
			type: GAME_PLAYER_INFO,
			payload: players?.data?.data?.playerInfo
		});
	} catch (err) {
		console.log(err);
		yield put({
			type: GAME_PLAYER_INFO_ERROR,
			payload: 'Unable to retrieve players'
		});
	}
}

function* fetchHealthScores(action) {
	const user = yield select(selectors.user);
	const matchID = action.payload.gameID;
	const isCricket = Number(user?.sportsID) === 4 || (user?.sportsName || '').toLowerCase() === 'cricket';
	try {
		const data = {
			matchID
		};
		console.log(data)
		const healthScoresUrl = isCricket
			? '/api/cricket/averagehealthscores'
			: `/main/${user.sportsID || 1}/averagehealthscores`;
		const healthScores = yield request(data, healthScoresUrl, 'POST', user?.token);
		yield put({
			type: HEALTH_SCORES_RECEIVED,
			payload: healthScores?.data?.data
		});
	} catch (err) {
		yield put({
			type: HEALTH_SCORES_ERROR,
			payload: 'Unable to retrieve health scores'
		});
	}
}

function* updateProfile(action) {
	try {
		const user = yield select(selectors.user);
		
		yield request(action.payload, `/update-profile`, 'PUT', user?.token);
		yield put({
			type: UPDATE_PROFILE_SUCCESS,
			payload: {
				...user,
				...action.payload
			}
		});
	} catch (err) {
		yield put({
			type: MATCH_ERROR,
			payload: 'You can access this data only after logging in or completing <a href="https://insideinjuries.com/signup" target="_blank" rel="noopener noreferrer">a free sign-up</a>.'
		});
	}
}

function* fetchMatch(action) {
	const matchID = action.payload.gameID;
	const user = yield select((state) => state.user);
	const isCricket = Number(user?.sportsID) === 4 || (user?.sportsName || '').toLowerCase() === 'cricket';
	let match;
	try {
		const matchupUrl = isCricket
			? `/api/cricket/matchup/${matchID}`
			: `/main/${user.sportsID || 1}/matchup/${matchID}`;
		match = yield request({}, matchupUrl, 'GET', user?.token);
		try {
			if (match?.data?.data?.match[0]?.date_time) {
				match.data.data.match[0].date_time = toLocalTime(match.data.data.match[0].date_time);
			}
		} catch (error) {
			console.log(error);
		}
		yield put({
			type: MATCH_SUCCESS,
			payload: match?.data?.data
		});
	} catch (err) {
		yield put({
			type: MATCH_ERROR,
			payload: 'You can access this data only after logging in or completing a <a href="https://insideinjuries.com/signup" target="_blank" rel="noopener noreferrer"> free sign-up</a>.'
		});
	}
	if (!isCricket) {
		try {
			const teamScores = yield request({}, `/main/${user.sportsID || 1}/healthScores`, 'GET', user?.token);
			yield put({
				type: TEAM_SCORES_RECEIVED,
				payload: teamScores.data?.data
			});
		} catch (err) {
			yield put({
				type: TEAM_SCORES_ERROR,
				payload: 'Unable to retrieve schedules'
			});
		}
	}
}

function* fetchTeamInfo(action) {
	const teamID = action.payload.teamID;
	const user = yield select((state) => state.user);
	try {
		const viewTeam = yield request({}, `/main/${user.sportsID || 1}/team/${teamID}`, 'GET', user?.token);
		yield put({
			type: VIEW_TEAM_SUCCESS,
			payload: {
				teamInfo: viewTeam?.data?.data?.teamInfo,
				playerInfo: viewTeam?.data?.data?.playerInfo,
				topFour: viewTeam?.data?.data?.topFour,
				teamTwitterInfo: viewTeam?.data?.data?.teamTwitterInfo,
				latestTeamsNews: viewTeam?.data?.data?.latestTeamsNews
			}
		});
	} catch (err) {
		yield put({
			type: VIEW_TEAM_ERROR,
			payload: 'Unable to retrieve team info'
		});
	}
}

function* fetchTeamSchedule(action) {
	const teamID = action.payload.teamID;
	const user = yield select((state) => state.user);
	try {
		const schedules = yield request({}, `/main/${user.sportsID || 1}/teamschedule/${teamID}`, 'GET', user?.token);
		yield put({
			type: TEAM_SCHEDULE_SUCCESS,
			payload: { teamInfo: schedules?.data?.data }
		});
	} catch (err) {
		const isUnauthorized =
			err?.response?.data?.type === 'UNAUTHORIZED' ||
			err?.data?.type === 'UNAUTHORIZED' ||
			err?.type === 'UNAUTHORIZED' ||
			err?.response?.status === 401 ||
			err?.statusCode === 401;
		yield put({
			type: TEAM_SCHEDULE_ERROR,
			payload: isUnauthorized
				? 'You can access this data only after logging in or completing a <a href="https://insideinjuries.com/signup" target="_blank" rel="noopener noreferrer"> free sign-up</a>.'
				: 'Unable to retrieve schedules for team'
		});
	}
}

function* fetchPlayerInfo(action) {
	const { playerID } = action.payload;
	const user = yield select((state) => state.user);
	const url = window.location.pathname.split('/');
	const sportsInfo = yield getSportIndex(url);
	const sportsID = sportsInfo ? sportsInfo.sportsID : 1;
	const sportsName = sportsInfo ? sportsInfo.sportsName : 'nfl';
	try {
		const result = yield request({}, `/main/${user.sportsID || sportsID}/${user.sportsName || sportsName}/playerinfo/${playerID}`, 'GET', user?.token);
		yield put({
			type: PLAYER_SUCCESS,
			payload: result?.data?.data
		});
	} catch (err) {
		yield put({
			type: PLAYER_ERROR,
			payload: 'Unable to retrieve player data'
		});
	}
}

function* getPrices(action) {
	let result;
	try {
		result = yield request({}, `/prices`, 'GET');
		yield put({
			type: GET_PRICES_SUCCESS,
			payload: { prices: result?.data?.data?.prices }
		});
	} catch (err) {
		yield put({
			type: GET_PRICES_ERROR,
			payload: { error: 'Error occured getting prices' }
		});
	}
}

function* actionWatcher() {
	yield takeLeading(CHECK_EXISTING_USER, checkExistingUser);
	yield takeLeading(GET_OPTIONS, getOptions);
	yield takeLeading(CHECK_LOGIN, checkLogin);
	yield takeLeading(REFRESH_USER, refreshUserInfo);
	yield takeLeading(MAKE_SAMPLE_TOKEN, makeSampleToken);
	yield takeLeading(UPDATE_PROFILE, updateProfile);
	yield takeLatest(GET_TRIAL_SCHEDULES, fetchTrialSchedules);
	yield takeLatest(GET_SCHEDULES, fetchSchedules);
	yield takeLatest(GET_HEALTH_SCORES, fetchHealthScores);
	yield takeLatest(GET_MATCH, fetchMatch);
	yield takeLatest(GET_PLAYER, fetchPlayerInfo);
	yield takeLatest(GET_PRICES, getPrices);

	// Login/Signup Section
	yield takeLeading(SIGNUP, signup);
	yield takeLeading(LOGIN, login);
	yield takeLeading(GOOGLE_AUTH, googleAuth);
	yield takeLeading(X_AUTH_EXCHANGE, xAuthExchange);
	yield takeLeading(X_AUTH_COMPLETE, xAuthComplete);
	yield takeLeading(LOGOUT, logout);
	yield takeLeading(SEND_PASSWORD_RESET, sendPasswordReset);
	yield takeLeading(VERIFY_PASSWORD_RESET_TOKEN, verifyPasswordReset);
	yield takeLeading(RESET_PASSWORD, resetPassword);

	// Teams Section
	yield takeLatest(VIEW_TEAM, fetchTeamInfo);
	yield takeLatest(TEAM_SCHEDULE, fetchTeamSchedule);

	// Admin Section
	yield takeLeading(GET_DASHBOARD_OPTIONS, adminDashboardOptions);
	yield takeLeading(ADMIN_DASHBOARD_SEARCH_SUBMIT, adminDashboardSearch);
	yield takeLeading(ADMIN_DASHBOARD_CHANGE_SUBMIT, adminDashboardChange);
	yield takeLeading(ADMIN_DASHBOARD_INSERT_SUBMIT, adminDashboardInsert);
	yield takeLeading(GET_ADMIN_CSV, adminDashboardCSV);
	yield takeLeading(RUN_CALCULATIONS, adminDashboardRunCalculations);
	yield takeLeading(GET_TEAM_HEALTH_SCORE_NFL, adminTeamHealthScoreNFL);
	yield takeLeading(SEARCH_GAMES, searchGames);
	yield takeLeading(SUBMIT_ADMIN_CHANGES, submitAdminChanges);

	// DFS "Pick of the Day"
	yield takeLatest(GET_DFS_PICKS, getDfsPicks);
	yield takeLatest(ADMIN_GET_DFS_PICKS, adminGetDfsPicks);
	yield takeLeading(ADMIN_SAVE_DFS_PICK, adminSaveDfsPick);
	yield takeLeading(ADMIN_DELETE_DFS_PICK, adminDeleteDfsPick);
	yield takeLatest(ADMIN_SEARCH_DFS_PLAYERS, adminSearchDfsPlayers);

	// Audit Section
	yield takeLeading(AUDIT, storeAudit);

	// Free Access Section
	yield takeLeading(FREE_ACCESS, freeAccess);

	// Admin TBD Return Dates
	yield takeLatest(GET_TBD_PLAYERS, getTBDPlayers);
	yield takeLeading(SET_PLAYER_RETURN_DATE, setPlayerReturnDate);
	yield takeLeading(CLEAR_PLAYER_RETURN_DATE, clearPlayerReturnDate);
}

export default function* rootSaga() {
	yield all([actionWatcher()]);
}